
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexqWhXXLJmEGU8d6eEK8euhVOt0JkwpeBZ0DdpydNlHlYMeta } from "C:/Users/Strains/Desktop/michael-strain/pages/index.vue?macro=true";
import { default as contact3sVXFoIBPT0z4GXRk4nhvy2K1Q1BnFrbCq5cnbQXLawMeta } from "C:/Users/Strains/Desktop/michael-strain/pages/contact.vue?macro=true";
import { default as indexhK07xkS5wlHeSIkt1g7M1QsXUdmwHyxGV_trYvE7gyQMeta } from "C:/Users/Strains/Desktop/michael-strain/pages/trpg/index.vue?macro=true";
import { default as privacyPolicyAYM7rMxnvW2X0XlcJzHM6g02AwVQOfUIrbPMiKZtntkMeta } from "C:/Users/Strains/Desktop/michael-strain/pages/legal/privacyPolicy.vue?macro=true";
import { default as termsAndConditionsjNsIepzM2A3RnBBBUgcZL7vskt9c7R4R1mXPbSz9qUoMeta } from "C:/Users/Strains/Desktop/michael-strain/pages/legal/termsAndConditions.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("C:/Users/Strains/Desktop/michael-strain/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("C:/Users/Strains/Desktop/michael-strain/pages/contact.vue")
  },
  {
    name: "trpg",
    path: "/trpg",
    component: () => import("C:/Users/Strains/Desktop/michael-strain/pages/trpg/index.vue")
  },
  {
    name: "legal-privacyPolicy",
    path: "/legal/privacyPolicy",
    component: () => import("C:/Users/Strains/Desktop/michael-strain/pages/legal/privacyPolicy.vue")
  },
  {
    name: "legal-termsAndConditions",
    path: "/legal/termsAndConditions",
    component: () => import("C:/Users/Strains/Desktop/michael-strain/pages/legal/termsAndConditions.vue")
  }
]